import { render, staticRenderFns } from "./GuideStationHeader.vue?vue&type=template&id=37f88d9c&scoped=true&"
import script from "./GuideStationHeader.vue?vue&type=script&lang=js&"
export * from "./GuideStationHeader.vue?vue&type=script&lang=js&"
import style0 from "./GuideStationHeader.vue?vue&type=style&index=0&id=37f88d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f88d9c",
  null
  
)

export default component.exports